"use strict";

var HTTP_METHODS = require('./helpers/http_methods');

var _require = require('./helpers/request_handler'),
    requestHandler = _require.requestHandler;

var _require2 = require('./helpers/constants'),
    URI = _require2.URI;

var mainMethods = {
  authenticate: function authenticate(params) {
    var endpoint = "".concat(URI, "/authenticate");
    return requestHandler(HTTP_METHODS.POST, endpoint, params);
  },
  getUser: function getUser() {
    var endpoint = "".concat(URI, "/user");
    return requestHandler(HTTP_METHODS.GET, endpoint);
  },
  getProjects: function getProjects() {
    var endpoint = "".concat(URI, "/projects");
    return requestHandler(HTTP_METHODS.GET, endpoint);
  },
  addProject: function addProject(params) {
    var endpoint = "".concat(URI, "/projects");
    return requestHandler(HTTP_METHODS.POST, endpoint, params);
  },
  getProject: function getProject(params) {
    var endpoint = "".concat(URI, "/projects/").concat(params.id);
    return requestHandler(HTTP_METHODS.GET, endpoint);
  },
  editProject: function editProject(params) {
    var endpoint = "".concat(URI, "/projects/").concat(params.id);
    delete params.id;
    return requestHandler(HTTP_METHODS.PATCH, endpoint, params);
  },
  deleteProject: function deleteProject(params) {
    var endpoint = "".concat(URI, "/projects/").concat(params.id);
    return requestHandler(HTTP_METHODS.DELETE, endpoint, params);
  },
  getBuckets: function getBuckets() {
    var endpoint = "".concat(URI, "/buckets");
    return requestHandler(HTTP_METHODS.GET, endpoint);
  },
  getBucket: function getBucket(params) {
    var endpoint = "".concat(URI, "/buckets/").concat(params.slug);
    return requestHandler(HTTP_METHODS.GET, endpoint);
  },
  addBucket: function addBucket(params) {
    var endpoint = "".concat(URI, "/buckets");
    return requestHandler(HTTP_METHODS.POST, endpoint, params);
  },
  editBucket: function editBucket(params) {
    var endpoint = "".concat(URI, "/buckets/").concat(params.slug);
    delete params.slug;
    return requestHandler(HTTP_METHODS.PATCH, endpoint, params);
  },
  deleteBucket: function deleteBucket(params) {
    var endpoint = "".concat(URI, "/buckets/").concat(params.slug);
    return requestHandler(HTTP_METHODS.DELETE, endpoint, params);
  }
};
module.exports = mainMethods;